'use strict';
var parent = require('../../actual/instance/map');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/map.js
// module id = 623
// module chunks = 13